// import {message} from 'ant-design-vue'
import Rule from './rule.vue'
import search from './search/search-routing'
import detail from './detail/detail-routing'

export default [{
        path: '/rule',
        name:'rule',
        component:Rule,
        children:[
            ...search,
            ...detail
        ]
    },
    {
        path: '',
        redirect: { name: 'rule' }
}]